import type { Question } from 'schema/poll';

export function selectCorrectIds(question: Question) {
  if (!('answers' in question.data) || !Array.isArray(question.data.answers)) return [];
  return question.data.answers.filter(it => ('isCorrect' in it ? it.isCorrect : false)).map(it => it.id);
}
